import { useState, useRef, useEffect } from "react";
import { withNavigationContext } from "../util/withNavigationContext";
import { InfoText } from "../views/comparison_views/molecules/InfoText";

const ILearn = ({ content, navigationContext, children }) => {
  const timeoutRef = useRef();
  const [showILearn, setShowILearn] = useState(false);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setShowILearn(true);
    }, 0);

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  useEffect(() => {
    setShowILearn(false);
  }, [navigationContext.lastNavigatedAt]);

  if (!content.tip) return children;
  return (
    <div className="mid-range-ilearn">
      {children}
      <div className={`ilearn ${showILearn ? "show" : ""}`}>
        <InfoText tip={content.tip} />
      </div>
    </div>
  );
};

export default withNavigationContext(ILearn);
